const Card = (props) => {
    return (
        <div className="card">
            <div className="emoji">
                {props.emoji.emoji}
            </div>
            <strong className="title">
                {props.emoji.name}
            </strong>
            <p className="description">
                {props.emoji.description}
            </p>
        </div>
    );
}

export default Card;